import React, { useState, useEffect } from 'react';
import { contactTexts, locationTexts } from '../contexts/LangCompany';
import contactBg from '../assets/images/contact-bg.png';

function ContactUse({ lang = 'ko' }) {
  const [isMobile, setIsMobile] = useState(false);
  const [form, setForm] = useState({
    company: '',
    email: '',
    phone: '',
    inquiry: ''
  });
  const [modal, setModal] = useState({
    isOpen: false,
    message: '',
    type: 'success' // 'success', 'error'
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const showModal = (message, type = 'success') => {
    setModal({ isOpen: true, message, type });
  };

  const closeModal = () => {
    setModal({ isOpen: false, message: '', type: 'success' });
    if (modal.type === 'success') {
      setForm({ company: '', email: '', phone: '', inquiry: '' }); // 성공 시 폼 초기화
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      // const response = await fetch('http://localhost:4000/api/contact', {
      const response = await fetch('http://www.rimahr.com:4000/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (response.ok) {
        showModal('문의가 정상적으로 접수되었습니다.', 'success');
      } else {
        showModal('서버 오류가 발생했습니다. 다시 시도해 주세요.', 'error');
      }
    } catch (err) {
      showModal('네트워크 오류가 발생했습니다. 인터넷 연결을 확인해 주세요.', 'error');
    }
  };

  const labels = contactTexts.labels[lang];

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100vw', // 가로 스크롤 방지
        overflowX: 'hidden', // 가로 스크롤 방지
        position: 'relative',
        fontFamily: `'Pretendard', 'Noto Sans KR', 'Apple SD Gothic Neo', Arial, sans-serif`
      }}
    >
      {/* 인트로 바탕화면 */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `url(${contactBg}) center/cover no-repeat`,
          zIndex: 0
        }}
      />
      {/* 문의 팝업 박스 */}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'center' : 'flex-start',
          justifyContent: isMobile ? 'flex-start' : 'flex-end',
          paddingTop: isMobile ? '120px' : '15vh',
          paddingBottom: isMobile ? '40px' : '0',
        }}
      >
        {/* 왼쪽 안내 문구 */}
        <div
          style={{
            flex: isMobile ? 'none' : '1 1 0',
            width: isMobile ? '100%' : 'auto',
            display: 'flex',
            flexDirection: 'column', // 세로 정렬
            alignItems: isMobile ? 'center' : 'flex-start',
            justifyContent: 'center',
            paddingLeft: isMobile ? '20px' : '5vw',
            paddingRight: isMobile ? '20px' : '0',
            marginBottom: isMobile ? '40px' : '0',
            color: '#fff',
            fontSize: isMobile ? '1.8rem' : '2.2rem',
            fontWeight: 700,
            textShadow: '0 2px 8px rgba(0,0,0,0.25)',
            textAlign: isMobile ? 'center' : 'left'
          }}
        >
          {!isMobile && <><br /><br /><br /><br /></>}{contactTexts.Title[lang]}
          <div style={{
            fontSize: isMobile ? '1rem' : '1.15rem',
            fontWeight: 400,
            marginTop: '24px',
            lineHeight: 1.7,
            color: '#fff',
            textAlign: isMobile ? 'center' : 'left'
          }}>
            {contactTexts.Titlemessage[lang]}
            {locationTexts.eMail[lang]} : <a href={`mailto:${locationTexts.eMailtext[lang]}`} style={{color:'#fff',textDecoration:'underline'}}>{locationTexts.eMailtext[lang]}</a><br />
            {locationTexts.Tel[lang]} : {locationTexts.Teltext[lang]}<br />
          </div>
        </div>
        <div
          style={{
            background: 'rgba(255,255,255,0.98)',
            borderRadius: 18,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            padding: isMobile ? '32px 24px' : '40px 32px',
            minWidth: isMobile ? 'auto' : 320,
            maxWidth: isMobile ? 'none' : 400,
            width: isMobile ? 'calc(100% - 40px)' : '100%',
            maxWidth: isMobile ? '400px' : '400px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginRight: isMobile ? '0' : '5vw',
            marginLeft: isMobile ? '0' : '0',
            marginTop: isMobile ? '0' : '48px'
          }}
        >
          <h1 style={{
            fontSize: isMobile ? '1.6rem' : '2rem',
            fontWeight: 700,
            color: '#29225C',
            marginBottom: isMobile ? 24 : 32,
            textAlign: 'center'
          }}>
            {labels.title}
          </h1>
          <form
            onSubmit={handleSubmit}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 18
            }}
          >
            <input
              name="company"
              value={form.company}
              onChange={handleChange}
              placeholder={labels.company}
              style={{ 
                padding: isMobile ? '12px' : '10px', 
                borderRadius: 6, 
                border: '1px solid #ccc', 
                fontSize: isMobile ? '16px' : '1rem',
                width: '100%',
                boxSizing: 'border-box'
              }}
            />
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder={labels.email}
              style={{ 
                padding: isMobile ? '12px' : '10px', 
                borderRadius: 6, 
                border: '1px solid #ccc', 
                fontSize: isMobile ? '16px' : '1rem',
                width: '100%',
                boxSizing: 'border-box'
              }}
              required
            />
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder={labels.phone}
              style={{ 
                padding: isMobile ? '12px' : '10px', 
                borderRadius: 6, 
                border: '1px solid #ccc', 
                fontSize: isMobile ? '16px' : '1rem',
                width: '100%',
                boxSizing: 'border-box'
              }}
              required
            />
            <textarea
              name="inquiry"
              value={form.inquiry}
              onChange={handleChange}
              placeholder={labels.inquiry}
              rows={isMobile ? 3 : 4}
              style={{ 
                padding: isMobile ? '12px' : '10px', 
                borderRadius: 6, 
                border: '1px solid #ccc', 
                fontSize: isMobile ? '16px' : '1rem', 
                resize: 'vertical',
                width: '100%',
                boxSizing: 'border-box',
                minHeight: isMobile ? '80px' : 'auto'
              }}
              required
            />
            <button
              type="submit"
              style={{
                marginTop: isMobile ? 16 : 8,
                padding: isMobile ? '14px 0' : '12px 0',
                borderRadius: 6,
                border: 'none',
                background: '#29225C',
                color: '#fff',
                fontWeight: 700,
                fontSize: isMobile ? '1rem' : '1.1rem',
                cursor: 'pointer',
                width: '100%',
                transition: 'background 0.3s ease'
              }}
              onMouseOver={(e) => e.target.style.background = '#3a2d7c'}
              onMouseOut={(e) => e.target.style.background = '#29225C'}
            >
              {labels.submit}
            </button>
          </form>
        </div>
      </div>

      {/* 커스텀 모달 */}
      {modal.isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: isMobile ? '20px' : '40px'
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: isMobile ? 12 : 18,
              padding: isMobile ? '24px 20px' : '32px 28px',
              maxWidth: isMobile ? '320px' : '400px',
              width: '100%',
              boxShadow: '0 12px 40px rgba(0, 0, 0, 0.25)',
              textAlign: 'center',
              position: 'relative',
              animation: 'modalSlideIn 0.3s ease-out'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* 모달 아이콘 */}
            <div
              style={{
                width: isMobile ? '50px' : '60px',
                height: isMobile ? '50px' : '60px',
                borderRadius: '50%',
                backgroundColor: modal.type === 'success' ? '#10B981' : '#EF4444',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px auto',
                fontSize: isMobile ? '24px' : '28px',
                color: '#fff'
              }}
            >
              {modal.type === 'success' ? '✓' : '✕'}
            </div>

            {/* 모달 메시지 */}
            <p
              style={{
                fontSize: isMobile ? '1rem' : '1.1rem',
                fontWeight: 500,
                color: '#333',
                lineHeight: 1.5,
                marginBottom: '24px',
                wordBreak: 'keep-all'
              }}
            >
              {modal.message}
            </p>

            {/* 확인 버튼 */}
            <button
              onClick={closeModal}
              style={{
                backgroundColor: modal.type === 'success' ? '#10B981' : '#EF4444',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: isMobile ? '12px 24px' : '14px 28px',
                fontSize: isMobile ? '0.95rem' : '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                minWidth: '80px',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = modal.type === 'success' ? '#059669' : '#DC2626';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = modal.type === 'success' ? '#10B981' : '#EF4444';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              확인
            </button>
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translateY(-20px) scale(0.95);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
        `}
      </style>
    </div>
  );
}

export default ContactUse;